import React from 'react'
import "./contactus.css"
import {motion} from 'framer-motion'

function Contactus() {
  return (
    <div align="center" style={{padding:"50px"}}>
    <br /><br />
      <motion.h1 style={{color:'black',fontSize:'47px'}} initial={{x:'-100vw'}} animate={{x:'0'}} transition={{type:'spring',delay:0.5}}>CONTACT US</motion.h1>
      <br />
      <motion.h3 style={{color:'black'}} initial={{x:'100vw'}} animate={{x:'0'}} transition={{type:'spring',delay:0.5}}>Do you have any questions? Please do not hesitate to contact us through any of our social media handles or fill the form below. Our team will come back to you within a few hours to help you.</motion.h3>
      <br /><br />
      <div className="row" >
        <div className="col">
        <a href="https://www.instagram.com/aakruthi_2022/" target="_blank" rel="noreferrer">
        <motion.img src="images/instagram .png" alt="img" style={{width:"40px"}} animate={{scale:1.4,rotate:360}} transition={{type:'spring',delay:0.5}}/>
      </a>
        </div>
        <div className="col">
        <a href="https://www.facebook.com/aakruthi2022" target="_blank" rel="noreferrer">
          <motion.img src="images/facebook.png" alt="img" style={{width:"40px"}} animate={{scale:1.4,rotate:360}} transition={{type:'spring',delay:0.5}}/>
        </a>
      </div>
      <div className="col">
        <a href="mailto:aakruthi2k22@gmail.com" target="_blank" rel="noreferrer">
          <motion.img src="images/gmail-logo.png" alt="img" style={{width:"40px"}} animate={{scale:1.4,rotate:360}} transition={{type:'spring',delay:0.5}}/>
        </a>
      </div>
      <div className="col">
        <a href="https://www.youtube.com/channel/UCyVBotDkjtZmnXrwcYQLFzA/featured" target="_blank" rel="noreferrer">
          <motion.img src="images/youtube.png" alt="img" style={{width:"40px"}} animate={{scale:1.4,rotate:360}} transition={{type:'spring',delay:0.5}}/>
        </a>
      </div>
      </div>
      <br /><br />
      <hr style={{color:'black'}}/>
      <br /><br />
      <motion.h2 style={{color:'black'}} initial={{x:'-100vw'}} animate={{x:'0'}} transition={{type:'spring',delay:0.5}}>CONTACT FORM</motion.h2>
      <motion.iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdAi9qd8Iy3PCaQfbdhCOtkjOnvJnzan6Lzm2LUzjuJKTn7rw/viewform" title="google-form" initial={{x:'100vw'}} animate={{x:'0'}} transition={{type:'spring',delay:0.5}}/>
      <br /><br />
      <hr style={{color:'black'}}/>
      <br /><br />
      <motion.h3 style={{color:'black'}} initial={{y:'-30vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>If it is a matter of urgency, you can reach us out at -</motion.h3>
      
      <br />
      <div className="row">
        <div className="col" style={{display:"flex", justifyContent:"center",alignItems:"center"}}>
          <motion.img src="images/call.png" alt="img" style={{width:"20px",marginRight:"10px"}} animate={{scale:1.5,rotate:360}} transition={{type:'spring',delay:0.5}}/>
          <motion.a href="https://wa.me/917330709167" target="_blank" style={{color:'black',fontSize:'15px',textDecoration:'none'}} initial={{y:'100vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>K.RAHUL - 7330709167</motion.a> 
        </div>
        <div className="col" style={{display:"flex", justifyContent:"center",alignItems:"center"}}>
          <motion.img src="images/call.png" alt="img" style={{width:"20px",marginRight:"10px"}} animate={{scale:1.5,rotate:360}} transition={{type:'spring',delay:0.5}}/>
          <motion.a href="https://wa.me/917330794622" target="_blank" style={{color:'black',fontSize:'15px',textDecoration:'none'}} initial={{y:'100vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>C. PRASHANTH - 7330794622</motion.a>
        </div>
      </div>
      <br />
      <div className="address" style={{color:'black'}}>
        <motion.h4 initial={{y:'100vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>Address :</motion.h4>
        <motion.p initial={{y:'100vh'}} animate={{y:'0'}} transition={{type:'spring',delay:0.5}}>Department of Electronics & Communication Engineering,<br /> Osmania University,<br /> Hyderabad,<br /> 500 007</motion.p>
        <motion.iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.0848103553476!2d78.51549761488727!3d17.407717106800305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb999f7625684b%3A0x4984ba37ecddab4!2sECE%20Department%2C%20Osmania%20University%2C%20Amberpet%2C%20Hyderabad%2C%20Telangana%20500044!5e0!3m2!1sen!2sin!4v1650180062514!5m2!1sen!2sin" title="map" initial={{x:'100vw'}} animate={{x:'0'}} transition={{type:'spring',delay:0.5}}/>
      </div>
      


      
    </div>
  )
}

export default Contactus